import { useState } from "react";
import { Link, useLocation } from "react-router-dom";

const LOGO_URL = "/images/logo.png";
const NAV_LINKS = [
  { label: "Home", path: "/" },
  { label: "About Us", path: "/about" },
  { label: "Flight Request", path: "/flight-request" },
  { label: "Hotel Request", path: "/hotel-request" },
  { label: "Visa Request", path: "/visa-request" },
];

export default function PublicLayout({ children }) {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();
  const [cookiesAccepted, setCookiesAccepted] = useState(() => {
    return localStorage.getItem('cookiesAccepted') === 'true';
  });

  const isActive = (path) => {
    if (path === "/") return location.pathname === "/";
    return location.pathname.startsWith(path);
  };

  return (
    <div className="min-h-screen bg-white pt-20" style={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}>
      {/* Header Bar */}
      <header className="tbf-header">
        <div className="max-w-7xl mx-auto px-6 flex items-center justify-between h-20">
          <Link to="/">
            <img src={LOGO_URL} alt="The Better Fare" className="h-16 w-auto" />
          </Link>
          {/* Desktop Nav */}
          <nav className="hidden md:flex items-center gap-6 text-sm text-gray-600">
            {NAV_LINKS.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={isActive(link.path) ? "tbf-nav-active" : "tbf-nav-inactive"}
style={isActive(link.path) ? { color: "#6C3084", textDecoration: "underline", textUnderlineOffset: "4px", fontWeight: 600 } : { color: "#1a1a1a", fontWeight: 600 }}
              >
                {link.label}
              </Link>
            ))}
            <div className="flex items-center gap-4 ml-4">
              <a href="https://www.facebook.com/TheBetterFare/" target="_blank" rel="noopener noreferrer" className="text-gray-600 hover:text-gray-900">
                <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="currentColor"><path d="M12 2C6.477 2 2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.879V14.89h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.989C18.343 21.129 22 16.99 22 12c0-5.523-4.477-10-10-10z"/></svg>
              </a>
              <a href="https://x.com/TheBetterFare" target="_blank" rel="noopener noreferrer" className="text-gray-600 hover:text-gray-900">
                <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="currentColor"><path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-4.714-6.231-5.401 6.231H2.744l7.737-8.835L1.254 2.25H8.08l4.253 5.622 5.911-5.622zm-1.161 17.52h1.833L7.084 4.126H5.117z"/></svg>
              </a>
              <a href="https://www.instagram.com/thebetterfare/" target="_blank" rel="noopener noreferrer" className="text-gray-600 hover:text-gray-900">
                <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="currentColor"><path d="M12 2c2.717 0 3.056.01 4.122.06 1.065.05 1.79.217 2.428.465.66.254 1.216.598 1.772 1.153.509.5.902 1.105 1.153 1.772.247.637.415 1.363.465 2.428.047 1.066.06 1.405.06 4.122 0 2.717-.01 3.056-.06 4.122-.05 1.065-.218 1.79-.465 2.428a4.883 4.883 0 01-1.153 1.772c-.5.508-1.105.902-1.772 1.153-.637.247-1.363.415-2.428.465-1.066.047-1.405.06-4.122.06-2.717 0-3.056-.01-4.122-.06-1.065-.05-1.79-.218-2.428-.465a4.89 4.89 0 01-1.772-1.153 4.904 4.904 0 01-1.153-1.772c-.248-.637-.415-1.363-.465-2.428C2.013 15.056 2 14.717 2 12c0-2.717.01-3.056.06-4.122.05-1.066.217-1.79.465-2.428a4.88 4.88 0 011.153-1.772A4.897 4.897 0 015.45 2.525c.638-.248 1.362-.415 2.428-.465C8.944 2.013 9.283 2 12 2zm0 1.802c-2.67 0-2.986.01-4.04.059-.976.045-1.505.207-1.858.344-.466.182-.8.398-1.15.748-.35.35-.566.683-.748 1.15-.137.353-.3.882-.344 1.857-.048 1.055-.058 1.37-.058 4.041 0 2.67.01 2.986.058 4.04.045.977.207 1.505.344 1.858.182.466.399.8.748 1.15.35.35.683.566 1.15.748.353.137.882.3 1.857.344 1.054.048 1.37.058 4.041.058 2.67 0 2.987-.01 4.04-.058.977-.045 1.505-.207 1.858-.344.466-.182.8-.398 1.15-.748.35-.35.566-.683.748-1.15.137-.353.3-.882.344-1.857.048-1.055.058-1.37.058-4.041 0-2.67-.01-2.986-.058-4.04-.045-.977-.207-1.505-.344-1.858a3.097 3.097 0 00-.748-1.15 3.098 3.098 0 00-1.15-.748c-.353-.137-.882-.3-1.857-.344-1.055-.048-1.37-.058-4.041-.058zm0 3.063a5.135 5.135 0 110 10.27 5.135 5.135 0 010-10.27zm0 8.468a3.333 3.333 0 100-6.666 3.333 3.333 0 000 6.666zm6.538-8.671a1.2 1.2 0 110 2.4 1.2 1.2 0 010-2.4z"/></svg>
              </a>
            </div>
          </nav>
          {/* Mobile Hamburger */}
          <button className="md:hidden flex flex-col gap-1.5 p-2" onClick={() => setMobileMenuOpen(!mobileMenuOpen)}>
            <span className="block w-6 h-0.5 bg-gray-700"></span>
            <span className="block w-6 h-0.5 bg-gray-700"></span>
            <span className="block w-6 h-0.5 bg-gray-700"></span>
          </button>
        </div>
        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div className="md:hidden bg-white border-t border-gray-100 px-6 py-4 flex flex-col gap-4 text-sm font-medium text-gray-700">
            {NAV_LINKS.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={isActive(link.path) ? "text-purple-700 font-semibold" : "hover:text-purple-700"}
                onClick={() => setMobileMenuOpen(false)}
              >
                {link.label}
              </Link>
            ))}
            <div className="flex items-center gap-4 pt-2">
              <a href="https://www.facebook.com/TheBetterFare/" target="_blank" rel="noopener noreferrer">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 24 24"><path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"/></svg>
              </a>
              <a href="https://x.com/TheBetterFare" target="_blank" rel="noopener noreferrer">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 24 24"><path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-4.714-6.231-5.401 6.231H2.744l7.737-8.835L1.254 2.25H8.08l4.253 5.622 5.911-5.622zm-1.161 17.52h1.833L7.084 4.126H5.117z"/></svg>
              </a>
              <a href="https://www.instagram.com/thebetterfare/" target="_blank" rel="noopener noreferrer">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 24 24"><rect x="2" y="2" width="20" height="20" rx="5" ry="5"/><path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" fill="white"/><line x1="17.5" y1="6.5" x2="17.51" y2="6.5" stroke="white" strokeWidth="2"/></svg>
              </a>
            </div>
          </div>
        )}
        <div className="tbf-header-line"></div>
      </header>

      {/* Main Content */}
      <main style={{ flex: 1 }}>
        {children}
      </main>

      {/* Footer */}
      <footer style={{ background: "#faf5ff", borderTop: "2px solid #e9d5ff" }}>
        <div className="max-w-7xl mx-auto px-6 py-12">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-10">

            {/* Brand */}
            <div>
              <img src={LOGO_URL} alt="The Better Fare" style={{ height: "48px", marginBottom: "16px" }} />
              <p style={{ fontFamily: "'Poppins', sans-serif", fontSize: "0.875rem", color: "#374151", lineHeight: 1.6, marginBottom: "12px" }}>
                Smarter Flights. Real People. Better Prices.
              </p>
              <p style={{ fontFamily: "'Poppins', sans-serif", fontSize: "0.75rem", color: "#9ca3af", lineHeight: 1.7, margin: 0 }}>
                KvK: 88159620 · BTW: NL003433847B38
              </p>
            </div>

            {/* Quick Links */}
            <div>
              <p style={{ fontFamily: "'Poppins', sans-serif", fontWeight: 700, fontSize: "0.7rem", color: "#6C3084", textTransform: "uppercase", letterSpacing: "1.5px", marginBottom: "14px" }}>
                Quick Links
              </p>
              <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                {[
                  { label: "Home", to: "/" },
                  { label: "About Us", to: "/about" },
                  { label: "Flight Request", to: "/flight-request" },
                  { label: "Visa Services", to: "/visa-request" },
                  { label: "Contact", to: "/contact" },
                ].map(({ label, to }) => (
                  <Link key={to} to={to} style={{ fontFamily: "'Poppins', sans-serif", fontSize: "0.875rem", color: "#374151", textDecoration: "none" }}>
                    {label}
                  </Link>
                ))}
              </div>
            </div>

            {/* Contact */}
            <div>
              <p style={{ fontFamily: "'Poppins', sans-serif", fontWeight: 700, fontSize: "0.7rem", color: "#6C3084", textTransform: "uppercase", letterSpacing: "1.5px", marginBottom: "14px" }}>
                Contact
              </p>
              <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
                <a href="mailto:info@thebetterfare.com" style={{ fontFamily: "'Poppins', sans-serif", fontSize: "0.875rem", color: "#374151", textDecoration: "none", display: "flex", alignItems: "center", gap: "8px" }}>
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#6C3084" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ flexShrink: 0 }}>
                    <rect x="2" y="4" width="20" height="16" rx="2"/>
                    <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"/>
                  </svg>
                  info@thebetterfare.com
                </a>
                <span style={{ fontFamily: "'Poppins', sans-serif", fontSize: "0.875rem", color: "#374151", display: "flex", alignItems: "center", gap: "8px" }}>
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#6C3084" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ flexShrink: 0 }}>
                    <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z"/>
                    <circle cx="12" cy="10" r="3"/>
                  </svg>
                  Arnhem, Netherlands
                </span>
                <a href="https://chat.whatsapp.com/FTpF0TyZG2nJkWpWKPdlrM?mode=hqrc" target="_blank" rel="noopener noreferrer" style={{ fontFamily: "'Poppins', sans-serif", fontSize: "0.875rem", color: "#374151", textDecoration: "none", display: "flex", alignItems: "center", gap: "8px" }}>
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="#6C3084" style={{ flexShrink: 0 }}>
                    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z"/>
                    <path d="M12 0C5.373 0 0 5.373 0 12c0 2.106.547 4.083 1.502 5.8L.057 23.25l5.638-1.481A11.94 11.94 0 0 0 12 24c6.627 0 12-5.373 12-12S18.627 0 12 0zm0 22c-1.891 0-3.667-.502-5.2-1.378l-.37-.22-3.853 1.011 1.03-3.764-.242-.386A9.937 9.937 0 0 1 2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10z"/>
                  </svg>
                  WhatsApp Group
                </a>
                <a href="https://maps.app.goo.gl/9zfFpfhCeFDPcYac8" target="_blank" rel="noopener noreferrer" style={{ fontFamily: "'Poppins', sans-serif", fontSize: "0.875rem", color: "#374151", textDecoration: "none", display: "flex", alignItems: "center", gap: "8px" }}>
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="#f59e0b" style={{ flexShrink: 0 }}>
                    <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
                  </svg>
                  Google Reviews
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div style={{ borderTop: "1px solid #e9d5ff" }}>
          <div className="max-w-7xl mx-auto px-6 py-4 flex flex-col sm:flex-row items-center justify-between gap-2">
            <p style={{ fontFamily: "'Poppins', sans-serif", fontSize: "13px", color: "#9ca3af", margin: 0 }}>
              © 2026 The Better Fare. All rights reserved.
            </p>
            <div style={{ display: "flex", gap: "16px" }}>
              <Link to="/terms" style={{ fontFamily: "'Poppins', sans-serif", fontSize: "13px", color: "#6b7280", textDecoration: "none" }}>Terms</Link>
              <Link to="/privacy" style={{ fontFamily: "'Poppins', sans-serif", fontSize: "13px", color: "#6b7280", textDecoration: "none" }}>Privacy</Link>
              <Link to="/contact" style={{ fontFamily: "'Poppins', sans-serif", fontSize: "13px", color: "#6b7280", textDecoration: "none" }}>Contact</Link>
            </div>
          </div>
        </div>
      </footer>
        {!cookiesAccepted && (
  <div style={{
    position: "fixed",
    bottom: 0,
    left: 0,
    right: 0,
    background: "#fff",
    borderTop: "1px solid #e5e7eb",
    padding: "16px 24px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    flexWrap: "wrap",
    gap: "12px",
    zIndex: 99999,
    boxShadow: "0 -2px 8px rgba(0,0,0,0.08)",
  }}>
    <p style={{ fontFamily: "'Poppins', sans-serif", fontSize: "0.875rem", color: "#555", margin: 0, maxWidth: "700px" }}>
      We use cookies to enhance your browsing experience. By continuing to use our site, you agree to our{" "}
      <Link to="/privacy" style={{ color: "#6C3084", fontWeight: 600 }}>Privacy Policy</Link>.
    </p>
    <div style={{ display: "flex", gap: "10px" }}>
      <button
        onClick={() => { setCookiesAccepted(true); localStorage.setItem('cookiesAccepted', 'true'); }}
        style={{
          background: "#6C3084",
          color: "#fff",
          border: "none",
          borderRadius: "4px",
          padding: "8px 20px",
          fontFamily: "'Poppins', sans-serif",
          fontWeight: 600,
          fontSize: "0.875rem",
          cursor: "pointer",
        }}
      >
        Accept
      </button>
      <button
        onClick={() => setCookiesAccepted(true)}
        style={{
          background: "#fff",
          color: "#555",
          border: "1px solid #ddd",
          borderRadius: "4px",
          padding: "8px 20px",
          fontFamily: "'Poppins', sans-serif",
          fontWeight: 600,
          fontSize: "0.875rem",
          cursor: "pointer",
        }}
      >
        Decline
      </button>
    </div>
  </div>
)}
    </div>
  );
}
